import dayjs from 'dayjs'
import { t } from '@/plugins/i18n'
import { isTikTokShop, isD2C, getCustomerShopPlatform } from '@/store'
import { getJapanTime } from '@/util/common'
import { productStatsEnum } from '../data'
import { abnormalDegreeDescList } from '@/common/const'
import { handleResult } from '.'
import { showCurrentUnit } from '@/util/useYan'
import { COUNTRY } from '@/global'
import {
  backendProductSku,
  getUserPurchaseAbnormalExtentApi
} from '@/apis/order'
import { ElMessage } from 'element-plus'
const defectiveAbnormalDictAbnormal: any = {
  101: t('到错货'),
  102: t('少件'),
  103: t('多件'),
  104: t('快递扫不出'),
  201: t('颜色差异'),
  202: t('商品上有中文'),
  203: t('配件差异'),
  204: t('logo差异'),
  205: t('尺码差异'),
  206: t('设计差异'),
  207: t('材质、面料差异'),
  301: t('$色差$2'),
  302: t('$污渍/斑点/水印$2'),
  303: t('$破损$2'),
  304: t('$线头$2'),
  305: t('$接缝不良$2'),
  306: t('$抽丝$2'),
  307: t('$针眼$2'),
  308: t('$霉菌$2'),
  309: t('$生锈$2'),
  310: t('$商品有中文$2'),
  311: t('$纽扣破损$2'),
  312: t('$拉链破损$2'),
  313: t('$附属品缺陷$2'),
  314: t('$有气味$2'),
  315: t('$其他不良$2'),
  316: t('$通电不良$2')
}
// 仓库次品登记
const defectiveAbnormalDictFlaw: any = {
  101: t('到错货'),
  102: t('少件'),
  103: t('多件'),
  104: t('快递扫不出'),
  201: t('颜色差异'),
  202: t('商品上有中文'),
  203: t('配件差异'),
  204: t('logo差异'),
  205: t('尺码差异'),
  206: t('设计差异'),
  207: t('材质、面料差异'),
  301: t('$色差$'),
  302: t('$污渍/斑点/水印$'),
  303: t('$破损$'),
  304: t('$线头$'),
  305: t('$接缝不良$'),
  306: t('$抽丝$'),
  307: t('$针眼$'),
  308: t('$霉菌$'),
  309: t('$生锈$'),
  310: t('$商品有中文$'),
  311: t('$纽扣破损$'),
  312: t('$拉链破损$'),
  313: t('$附属品缺陷$'),
  314: t('$有气味$'),
  315: t('$其他不良$'),
  316: t('$通电不良$'),
  317: t('尺码差异2'),
  318: t('配件差异2'),
  319: t('设计差异2'),
  320: t('染色不良'),
  321: t('抽绳不良')
}
const changeUrl = (url: string) => {
  if (!url) return url
  if (!url.includes('http')) {
    return `https:${url}`
  }
  return url
}
const defectiveAbnormalDict = (rowItem: any) => {
  return rowItem.type === 8
    ? defectiveAbnormalDictAbnormal
    : defectiveAbnormalDictFlaw
}
const getDefectiveProductContent = (rowItem: any) => {
  const { abnormalDetailMessageJp } = rowItem
  const content: string[] = []
  abnormalDetailMessageJp?.split(',')?.forEach((e: string) => {
    content.push(defectiveAbnormalDict(rowItem)[e] || '')
  })
  return content
}
const showContentList = (
  rowItem: any,
  productSellPrice?: any,
  isHaveShopPurchase?: any,
  checkedProduct?: any
) => {
  const {
    type,
    abnormalDetailType,
    userExpected,
    remark,
    purchaseUserProductLink,
    changeLinkSellPrice
  } = rowItem
  // ("type 异常类型 1 商品确认 2 全网断货 3 原商品缺货 4 预售商品 5 不满足最小起订量 6 更换采购链接 7 次品件 8 异常次品件 9 客户退款 10 到错货 11 多件 12 少件 13 扫不出 14 商品下架 15 商品异常")
  switch (type) {
    case 1:
      switch (abnormalDetailType) {
        case 1:
          return [t('确认尺码')]
        case 2:
          return [t('确认颜色')]
        case 3:
          return [t('确认款式')]
        case 14:
          return [t('无法按拼团价进行采购，需按原价进行采购')]
        default:
          return []
      }
    case 2:
      return [t('全网断货')]
    case 3:
      switch (abnormalDetailType) {
        case 4:
          return !userExpected
            ? [
                t('原商品缺货-推荐同款-价格不符合客户预期')
                  .replace('X', checkedProduct?.price ?? 0)
                  .replaceAll('H', purchaseUserProductLink)
              ]
            : []
        case 5:
          return [
            t('原商品缺货-推荐类似款')
              .replace('X', checkedProduct?.price ?? 0)
              .replaceAll('H', purchaseUserProductLink)
          ]
        default:
          return []
      }
    case 4:
      switch (abnormalDetailType) {
        case 4:
          return [
            t('预售商品-推荐同款商品')
              .replace('X', remark ?? 0)
              .replaceAll('H', purchaseUserProductLink)
          ]
        case 6:
          return [t('预售商品-无同款商品推荐').replace('X', remark ?? 0)]
        default:
          return []
      }
    case 5:
      switch (abnormalDetailType) {
        case 4:
          return [
            t('不满足最小起量-推荐同款商品')
              .replace('X', remark ?? 0)
              .replace('Y', rowItem.num)
              .replaceAll('H', purchaseUserProductLink)
          ]
        case 6:
          return [
            t('不满足最小起量-无同款商品推荐')
              .replace('X', remark ?? 0)
              .replace('Y', rowItem.num)
          ]
        default:
          return []
      }
    case 6:
      return !userExpected
        ? [
            t('更换同款链接-价格不符合客户预期').replaceAll(
              'H',
              purchaseUserProductLink
            )
          ]
        : []
    case 7:
    case 8:
      return getDefectiveProductContent(rowItem)
    case 10:
      // 未配置次品付费重拍和配置文案区分
      return [
        (isHaveShopPurchase === 0
          ? t(
              '因原商品质量不佳，我们为您自动寻找了以下新链接，请您确认是否需要再新链接下重拍'
            )
          : t(
              '因原商品质量不佳，我们为您重拍时自动寻找了以下新链接，但新链接价格不符合您的预期，请您确认'
            )
        )
          .replace('X', productSellPrice)
          .replaceAll('H', purchaseUserProductLink)
      ]
    case 12:
      return [
        t('原URL缺货，新的URL内商品是X元，请确认')
          .replace('X', productSellPrice)
          .replaceAll('H', purchaseUserProductLink)
      ]
    default:
      return []
  }
}
const isgroupResult: any = (rowItem: any) => {
  //      是否直发      是否重拍               采购配置              重拍上限           仓库异常   客户配置         是否是转成囤货单
  const {
    orderType,
    purchaseRemakeStatus,
    purchaseOperateType,
    reachMaxRemakeTimes,
    type,
    payRepurchaseType,
    transformStockStatus
  } = rowItem
  if (orderType !== 1 && transformStockStatus !== 1) {
    return false
  }
  if (type === 7 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '$次品重拍达到上限$'
  }
  if (type === 7 && payRepurchaseType === 2) {
    // groupAbnormal.value = '由于您选择次品退货退款，未触发次品重拍'
    return '由于您选择次品退货退款，未触发次品重拍'
  }
  if (type === 12 && purchaseOperateType === 35 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 12 && purchaseOperateType === 35 && reachMaxRemakeTimes === 0) {
    // groupAbnormal.value = '全网断货'
    return '$全网断货$'
  }
  if (type === 10 && reachMaxRemakeTimes === 1 && purchaseRemakeStatus === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 10 && payRepurchaseType === 2 && purchaseRemakeStatus === 2) {
    // groupAbnormal.value = '由于您选择次品退货退款，未触发次品重拍'
    return '由于您选择次品退货退款，未触发次品重拍'
  }
  if (type === 10 && purchaseRemakeStatus === 2 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 10 && purchaseRemakeStatus === 2) {
    // groupAbnormal.value = '全网断货'
    return '$全网断货$'
  }
  return false
}
// 最终数据格式
// const data = [
//   ['姓名', '年龄', '城市'],
//   ['张三', 18, '北京'],
//   ['李四', 20, '上海']
// ]
function exportCSV (data: any, filename = 'data.csv') {
  const csvContent = data
    .map((row: any) =>
      row
        .map((item: any) =>
          typeof item === 'string' && item.includes(',') ? `"${item}"` : item
        )
        .join(',')
    )
    .join('\n')
  const BOM = '\uFEFF'
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')

  link.href = URL.createObjectURL(blob)
  link.download = filename
  link.click()
  ElMessage.success(t('导出成功'))
  URL.revokeObjectURL(link.href)
}
export const exportFile = async (data: any) => {
  // 展示条件 1 2c 2 2b 3 不是tk店铺
  const auth: any = []
  auth.push(isD2C() ? 1 : 2)
  if (!isTikTokShop()) {
    auth.push(3)
  }
  const thData = [
    {
      title: t('THE CKB订单编号'),
      formatData: (item: any) => {
        return item.platformOrderNo
      }
    },
    {
      title: t('客户订单编号'),
      formatData: (item: any) => {
        return item.customerOrderNo
      },
      show: [1]
    },
    {
      title: t('订单') + `(${getCustomerShopPlatform()})`,
      formatData: (item: any) => {
        return item.orderName
      },
      show: [1, 3]
    },
    {
      title: t('订单标题'),
      formatData: (item: any) => {
        return item.customerOrderNo
      },
      show: [2]
    },
    {
      title: '商品画像',
      formatData: (item: any) => {
        return changeUrl(item.productImg)
      }
    },
    {
      title: '商品情報',
      formatData: (item: any) => {
        return item.productName
      }
    },
    {
      title: '商品のプロパティ',
      formatData: (item: any) => {
        return item.productProp?.replace(/[+-]?\d+:[+-]?\d+:/, '')
      }
    },
    {
      title: 'THE CKB SKU',
      formatData: (item: any) => {
        return item.productSku
      }
    },
    {
      title: 'お客様商品sku',
      formatData: (item: any) => {
        return item.shopProductSku
      }
    },
    {
      title: '注文数',
      formatData: (item: any) => {
        return item?.orderItemStatusInfoDTO?.orderQuantity ?? ''
      }
    },
    {
      title: '連絡日',
      formatData: (item: any) => {
        return getJapanTime(item.createTime)
      }
    },
    {
      title: 'ステータス',
      formatData: (item: any) => {
        const list = []
        for (const v of item.orderItemStatusInfoDTO?.orderItemStatusList ||
          []) {
          list.push(
            `${productStatsEnum[v.orderItemStatus]}(${v.commodityQuantity})`
          )
        }
        return list.join(',')
      }
    },
    {
      title: '連絡理由',
      formatData: async (item: any) => {
        let checkedProduct = {}
        let isHaveShopPurchase = false
        let productSellPrice = 0
        if ([4, 5].includes(item.abnormalDetailType)) {
          const res = await backendProductSku({
            productSku: item.purchaseUserProductSku
          })
          for (const e of res.data.skuList || []) {
            if (e.productSku === item.purchaseUserProductSku) {
              console.log('e', e)
              const properties = e.productPropertiesName
                .split(';')
                .map((v: any) => v.replace(/[+-]?\d+:[+-]?\d+:/, ''))
              checkedProduct = {
                productSku: e.productSku,
                productCode: e.productCode,
                props: properties.join(' '),
                link: res.data.productDetailUrl,
                price: e.productSellPrice
              }
              break
            }
          }
        }
        if (item.type === 8 || item.type === 12 || item.type === 10) {
          // 获取状态和价格
          const res2: any = await getUserPurchaseAbnormalExtentApi({
            purchaseAbnormalOrderId: item.purchaseAbnormalOrderId
          })
          isHaveShopPurchase = res2.data.isHaveShopPurchase
          productSellPrice = res2.data.productSellPrice
        }
        if (item.abnormalDetailMessageSeverity) {
          const list = JSON.parse(item.abnormalDetailMessageSeverity ?? '[]')
          return list
            ?.map(
              (v: any) =>
                `${abnormalDegreeDescList[v.abnormalCode]}-${
                  abnormalDegreeDescList[v.abnormalSeverityCode]
                }`
            )
            .join(',')
        } else if (isgroupResult(item)) {
          return t(isgroupResult(item)).replace(
            '元',
            showCurrentUnit(item.supplierCountry === COUNTRY.KR)
          )
        } else {
          return showContentList(
            item,
            productSellPrice,
            isHaveShopPurchase,
            checkedProduct
          )
        }
      }
    },
    {
      title: '不良品写真',
      formatData: (item: any) => {
        return (
          item?.imageList?.map((v: any) => changeUrl(v.image))?.join(',') ??
          changeUrl(item.productImg)
        )
      }
    },
    {
      title: '販売サイトに載せた画像',
      formatData: (item: any) => {
        return item.ztImg
          ?.split(',')
          .map((v: any) => changeUrl(v))
          ?.join(',')
      }
    },
    {
      title: '不良数量',
      formatData: (item: any) => {
        return item.num
      }
    },
    {
      title: '対応ステータス',
      formatData: (item: any) => {
        return handleResult(item)
      }
    }
  ].filter(v => !v.show || v.show.every((item: number) => auth.includes(item)))
  const list = []
  list.push(thData.map(v => v.title))
  // data.forEach((item: any) => {
  //   list.push(thData.map(v => v.formatData(item)))
  // })
  console.log(list)
  for (const item of data) {
    const l = await fn(item, thData)
    console.log('for-1')
    list.push(l)
  }
  console.log('for-over', list)
  exportCSV(list, `異常注文履歴_${dayjs().format('YYYY-MM-DD')}.csv`)
}

const fn = async (item: any, thData: any) => {
  const arr = []
  for (const temp of thData) {
    const str = await temp.formatData(item)
    const div = document.createElement('div')
    div.innerHTML = str ?? ''
    arr.push(div.textContent || div.innerText || '')
    console.log('fn1')
  }

  console.log('fn-over')
  return arr
}
